import React from "react";

import Actions from "./Actions";

const showAssignTeam = (dispatch, actions, row) => {
  actions.loadTeams(dispatch, row);
};

const columns = (dispatch, actions) => [
  {
    name: "Coach Pool Name",
    selector: "attributes.name",
    sortable: true,
  },
  {
    name: "Date Created",
    selector: "attributes.created_date_formatted",
    sortable: true,
    center: true,
    sortFunction: (a, b) =>
      a.attributes.created_date_timestamp - b.attributes.created_date_timestamp,
  },
  {
    name: "Number of Coaches",
    selector: "attributes.coach_count",
    sortable: true,
    center: true,
  },
  {
    name: "Assigned to",
    selector: "attributes.assigned_count",
    sortable: true,
    center: true,
    cell: (row) => (
      <>
        {row.attributes.assigned_count == "N/A" && (
          <span>{row.attributes.assigned_count}</span>
        )}
        {row.attributes.assigned_count != "N/A" && (
          <a onClick={() => showAssignTeam(dispatch, actions, row)}>
            {row.attributes.assigned_count}
          </a>
        )}
      </>
    ),
  },
  {
    name: "Actions",
    sortable: false,
    width: "190px",
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
